import MediaOwnerLabelProps from './MediaOwnerLabel.types';

export const MediaOwnerLabel = ({ isReseller, mediaOwner, name }: MediaOwnerLabelProps): React.ReactElement => (
  <div>
    {isReseller && mediaOwner && <div>{mediaOwner}:</div>}
    {name}
  </div>
);
